import { BaseService } from "./BaseService";
import type {
  AnalyticsServicesRangeQuery,
  ServiceDiscountImpactResponse,
  ServicePopularityResponse,
  ServiceReviewsResponse,
  ServicesListExportQuery,
  ServicesListQuery,
  ServicesListResponse,
  ServicesUsageQuery,
  ServicesUsageResponse,
  ServiceUsageByDayResponse,
} from "@/types/analytics-services";

class AnalyticsServicesService extends BaseService {
  private readonly basePath = "/analytics/services";

  getList(query: ServicesListQuery): Promise<ServicesListResponse> {
    return this.get<ServicesListResponse>(this.basePath, query);
  }

  getUsage(query: ServicesUsageQuery): Promise<ServicesUsageResponse> {
    return this.get<ServicesUsageResponse>(`${this.basePath}/usage`, query);
  }

  exportList(query: ServicesListExportQuery): Promise<Blob> {
    return this.getBlob(`${this.basePath}/export`, query);
  }

  getPopularity(
    serviceId: string,
    query: AnalyticsServicesRangeQuery,
  ): Promise<ServicePopularityResponse> {
    return this.get<ServicePopularityResponse>(
      `${this.basePath}/${serviceId}/popularity`,
      query,
    );
  }

  getUsageByDay(
    serviceId: string,
    query: AnalyticsServicesRangeQuery,
  ): Promise<ServiceUsageByDayResponse> {
    return this.get<ServiceUsageByDayResponse>(
      `${this.basePath}/${serviceId}/usage-by-day`,
      query,
    );
  }

  getDiscountImpact(
    serviceId: string,
    query: AnalyticsServicesRangeQuery,
  ): Promise<ServiceDiscountImpactResponse> {
    return this.get<ServiceDiscountImpactResponse>(
      `${this.basePath}/${serviceId}/discount-impact`,
      query,
    );
  }

  getReviews(
    serviceId: string,
    query: AnalyticsServicesRangeQuery,
  ): Promise<ServiceReviewsResponse> {
    return this.get<ServiceReviewsResponse>(
      `${this.basePath}/${serviceId}/reviews`,
      query,
    );
  }
}

export const analyticsServicesService = new AnalyticsServicesService();
